(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[962],{

/***/ 2133:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/credit-bg.624b93fb.jpg","height":1024,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAYACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABwEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAKuJf//EABYQAAMAAAAAAAAAAAAAAAAAAAASIv/aAAgBAQABPwBoP//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQIBAT8Af//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQMBAT8Af//Z","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 7869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _public_sounds_ClickGeneral_mp3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3511);
/* harmony import */ var _public_sounds_ClickGeneral_mp3__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_public_sounds_ClickGeneral_mp3__WEBPACK_IMPORTED_MODULE_0__);

// sounds funciton
var playClick = function() {
    var player = new Audio((_public_sounds_ClickGeneral_mp3__WEBPACK_IMPORTED_MODULE_0___default()));
    player.play();
};
/* harmony default export */ __webpack_exports__["Z"] = (playClick);


/***/ }),

/***/ 9148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _public_sounds_HoverGeneral_mp3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1966);
/* harmony import */ var _public_sounds_HoverGeneral_mp3__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_public_sounds_HoverGeneral_mp3__WEBPACK_IMPORTED_MODULE_0__);

// sounds funciton
var playHover = function() {
    var player = new Audio((_public_sounds_HoverGeneral_mp3__WEBPACK_IMPORTED_MODULE_0___default()));
    player.play();
};
/* harmony default export */ __webpack_exports__["Z"] = (playHover);


/***/ }),

/***/ 1469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6537);
/* harmony import */ var _arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _icons_arrow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6267);








function ArrowButton(_param) {
    var link = _param.link, text = _param.text, color = _param.color, textColor = _param.textColor, type = _param.type, openIn = _param.openIn, round = _param.round, bgColor = _param.bgColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "link",
        "text",
        "color",
        "textColor",
        "type",
        "openIn",
        "round",
        "bgColor"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: type === "button" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            className: "flex justify-center items-center ".concat((_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button)),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text relative ".concat(round ? "" : (_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text)),
                    style: {
                        color: textColor,
                        "--color": textColor
                    },
                    children: text
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    style: {
                        backgroundColor: bgColor
                    },
                    className: "flex items-center justify-center ".concat(round && (_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().iconRound), " ").concat((_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().icon)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_arrow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            color: color
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                borderColor: color
                            },
                            className: (_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().after)
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: link,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                className: "flex justify-center items-center ".concat((_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button)),
                target: openIn,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text relative ".concat(round ? "" : (_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text)),
                        style: {
                            color: textColor,
                            "--color": textColor
                        },
                        children: text
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        style: {
                            backgroundColor: bgColor
                        },
                        className: "flex items-center justify-center ".concat(round && (_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().iconRound), " ").concat((_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().icon)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_arrow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                color: color
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    borderColor: color
                                },
                                className: (_arrowbutton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().after)
                            })
                        ]
                    })
                ]
            })
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ArrowButton);


/***/ }),

/***/ 6267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function Arrow(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "28",
            height: "22",
            viewBox: "0 0 28 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.0997 21.9805C17.7071 21.9805 17.8553 21.6362 17.4218 21.2027L10.4675 14.2484C10.0378 13.8187 10.1799 13.4705 10.7865 13.4705L26.2365 13.4705C26.8423 13.4705 27.3333 12.9788 27.3333 12.3741L27.3333 9.62594C27.3333 9.02047 26.8431 8.52947 26.2365 8.52947L10.7865 8.52947C10.1806 8.52947 10.0336 8.18519 10.4675 7.75167L17.4218 0.797351C17.8511 0.367665 17.7079 0.0195474 17.0997 0.0195474L12.3111 0.0195478C11.7037 0.0195479 10.8646 0.366136 10.4349 0.796205L1.00745 10.2233C0.578912 10.6522 0.577765 11.3465 1.00745 11.7766L10.4349 21.2037C10.8638 21.6326 11.7029 21.9803 12.3111 21.9803L17.0997 21.9805Z",
                fill: color ? color : "#4A5A72"
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Arrow);


/***/ }),

/***/ 5962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/layout/footer/footer.js


function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "Footer"
    });
}
/* harmony default export */ var footer_footer = (Footer);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/layout/header/header.module.scss
var header_module = __webpack_require__(5851);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
;// CONCATENATED MODULE: ./public/images/logo-black.svg
/* harmony default export */ var logo_black = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/logo-black.df0ad8d9.svg","height":107,"width":48});
;// CONCATENATED MODULE: ./src/components/icons/soundIcon.js


function SoundIcon(param) {
    var data = param.data;
    //console.log(data);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data == false ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "play",
            width: "18",
            height: "21",
            viewBox: "0 0 18 21",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.695 15.6368L5.88266 5.82452H6.83923C7.42179 5.79647 7.98594 5.61157 8.47234 5.28934L14.9659 0.520324C15.3651 0.226346 15.695 0.39287 15.695 0.88915L15.695 15.6368ZM15.695 17.9881L3.52835 5.82442L1.23802 3.53408L0.0625 4.7096L1.78171 6.42881C1.74496 6.52436 1.7262 6.62589 1.7262 6.7284V12.8115C1.72698 13.0509 1.82233 13.2805 1.99175 13.4497C2.16118 13.6192 2.39056 13.7147 2.63021 13.7153H6.83914C7.42171 13.7433 7.98585 13.9282 8.47226 14.2505L12.7255 17.3726L15.9778 20.625L17.1533 19.4466L15.695 17.9881Z",
                    fill: "#4A5A72"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.695 15.6368L5.88266 5.82452H6.83923C7.42179 5.79647 7.98594 5.61157 8.47234 5.28934L14.9659 0.520324C15.3651 0.226346 15.695 0.39287 15.695 0.88915L15.695 15.6368ZM15.695 17.9881L3.52835 5.82442L1.23802 3.53408L0.0625 4.7096L1.78171 6.42881C1.74496 6.52436 1.7262 6.62589 1.7262 6.7284V12.8115C1.72698 13.0509 1.82233 13.2805 1.99175 13.4497C2.16118 13.6192 2.39056 13.7147 2.63021 13.7153H6.83914C7.42171 13.7433 7.98585 13.9282 8.47226 14.2505L12.7255 17.3726L15.9778 20.625L17.1533 19.4466L15.695 17.9881Z",
                    fill: "#ffffff"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.695 15.6368L5.88266 5.82452H6.83923C7.42179 5.79647 7.98594 5.61157 8.47234 5.28934L14.9659 0.520324C15.3651 0.226346 15.695 0.39287 15.695 0.88915L15.695 15.6368ZM15.695 17.9881L3.52835 5.82442L1.23802 3.53408L0.0625 4.7096L1.78171 6.42881C1.74496 6.52436 1.7262 6.62589 1.7262 6.7284V12.8115C1.72698 13.0509 1.82233 13.2805 1.99175 13.4497C2.16118 13.6192 2.39056 13.7147 2.63021 13.7153H6.83914C7.42171 13.7433 7.98585 13.9282 8.47226 14.2505L12.7255 17.3726L15.9778 20.625L17.1533 19.4466L15.695 17.9881Z",
                    fill: "#4A5A72"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "19",
            height: "20",
            viewBox: "0 0 19 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.8802 0.553053V19.4525C14.8802 19.981 14.5317 20.1582 14.1036 19.8453L7.18769 14.7749C6.66984 14.4316 6.06875 14.2346 5.44835 14.205H0.968538C0.713939 14.2058 0.469432 14.1061 0.287968 13.9273C0.106493 13.7487 0.00309014 13.5056 0 13.2513V6.75457C0.00082395 6.49956 0.102375 6.25525 0.282822 6.07479C0.463063 5.89435 0.707569 5.79279 0.962601 5.79197H5.45127C6.07194 5.76231 6.67277 5.56538 7.19061 5.22198L14.1039 0.154462C14.5319 -0.158434 14.8805 0.0187168 14.8805 0.553254L14.8802 0.553053ZM16.5813 12.3209H16.581C17.4073 12.3209 18.1705 11.8801 18.5837 11.1647C18.9967 10.4493 18.9967 9.56789 18.5837 8.85246C18.1705 8.13709 17.4073 7.69645 16.581 7.69645",
                fill: "#4A5A72"
            })
        })
    });
}
/* harmony default export */ var soundIcon = (SoundIcon);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/actions/default-click.js
var default_click = __webpack_require__(7869);
// EXTERNAL MODULE: ./src/components/actions/default-hover.js
var default_hover = __webpack_require__(9148);
// EXTERNAL MODULE: ./src/components/layout/nav/nav.module.scss
var nav_module = __webpack_require__(1658);
var nav_module_default = /*#__PURE__*/__webpack_require__.n(nav_module);
;// CONCATENATED MODULE: ./src/components/layout/nav/nav.js








function Nav() {
    var menuItems = [
        {
            title: "פתיחה",
            color: "#93A0C1",
            link: "/story/",
            id: 1
        },
        {
            title: "המשפחה והפרידה",
            color: "#E7C1B3",
            link: "/story/room1/",
            id: 2
        },
        {
            title: "המסתור",
            color: "#798667",
            link: "/story/room2/",
            id: 3
        },
        {
            title: "הפדיון",
            color: "#EAE0BD",
            link: "/story/room3/",
            id: 4
        },
        {
            title: "השיקום",
            color: "#FFFFFF",
            link: "/story/room4/",
            id: 5
        },
        {
            title: "סיום",
            color: "#FFFFFF",
            link: "/story/end/",
            id: 6
        }
    ];
    //console.log(menuItems[0].title)
    // Use 
    var router = (0,next_router.useRouter)();
    //console.log(router.asPath);
    (0,react.useEffect)(function() {
        // Add Activated class
        var nodes = Array.prototype.slice.call(document.getElementById("menu").children);
        var active = document.getElementById("menu").querySelectorAll(".active")[0];
        var index = 0;
        //console.log(nodes.indexOf(active));
        nodes === null || nodes === void 0 ? void 0 : nodes.map(function(item) {
            if (index < nodes.indexOf(active)) {
                item.classList.add("wasActive");
            }
            index++;
        });
    });
    //console.log(router);
    var locs = router.asPath.replace(/\.\w+$/, "").split("/");
    var output = locs.slice(0, 3).join("/");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "".concat((nav_module_default()).nav),
        id: "nav-menu",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            id: "menu",
            className: "".concat((nav_module_default()).navList, " menu relative"),
            children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "z-30 relative ".concat(item.link == router.asPath || item.link == output + "/" ? "active" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            onClick: function() {
                                return (0,default_click/* default */.Z)();
                            },
                            onMouseEnter: function() {
                                return (0,default_hover/* default */.Z)();
                            },
                            className: "block relative ".concat(item.link == router.asPath || item.link == output + "/" ? (nav_module_default()).active : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((nav_module_default()).marker, " block rounded-full z-10 transition-all absolute left-2/4 top-2/4")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((nav_module_default()).hover, " hover block rounded-full z-20 transition-all absolute w-full h-full top-0 right-0"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "absolute block rounded-full",
                                        style: {
                                            borderColor: item.color
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "".concat((nav_module_default()).tooltip, " overflow-hidden rounded-full h-full absolute top-0 right-0 z-30 transition-all delay-150"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat((nav_module_default()).tipbg, " absolute z-10 border-2 rounded-full"),
                                            style: {
                                                borderColor: item.color
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat((nav_module_default()).tiptext, " block z-20 absolute transition-all delay-200 w-full text-center"),
                                            children: item.title
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }, item.id);
            })
        })
    });
}
/* harmony default export */ var nav = (Nav);

// EXTERNAL MODULE: ./node_modules/gsap/dist/gsap.js
var gsap = __webpack_require__(458);
// EXTERNAL MODULE: ./src/components/arrowButton/index.js
var arrowButton = __webpack_require__(1469);
// EXTERNAL MODULE: ./public/images/credit-bg.jpg
var credit_bg = __webpack_require__(2133);
;// CONCATENATED MODULE: ./src/components/layout/header/header.js














function Header(param) {
    var music = param.music, setHide = param.setHide, music2 = param.music2;
    var isMusicPlaying = function isMusicPlaying(audelem) {
        return !(audelem === null || audelem === void 0 ? void 0 : audelem.paused);
    };
    // Get the background music
    var backAudio = localStorage.getItem("backgroundMusic");
    // Use Router
    var router = (0,next_router.useRouter)();
    // Update Music
    var ref = (0,react.useState)(backAudio === "playing" ? true : false), isPlaying = ref[0], setIsPlaying = ref[1];
    var ref1 = (0,react.useState)(false), openMenu = ref1[0], setOpenMenu = ref1[1];
    var ref2 = (0,react.useState)(false), disableButton = ref2[0], setDisableButton = ref2[1];
    // Get Page name
    var locs = router.asPath.replace(/\.\w+$/, "").split("/");
    (0,react.useEffect)(function() {
        // Player on change
        if (isPlaying) {
            //console.log(locs[locs.length - 2]);
            if (locs[locs.length - 2] !== "room2" && locs[locs.length - 2] !== "room3" && locs[locs.length - 2] !== "hidden-secret" && locs[locs.length - 2] !== "monastery" && locs[locs.length - 2] !== "fake-identity" && locs[locs.length - 2] !== "children" && router.asPath !== "/story/room2/result/" && router.asPath !== "/story/room3/result/") {
                // Music 2
                if (isMusicPlaying(music2) && music2) {
                    gsap.gsap.to(music2, {
                        volume: 0,
                        duration: 1.5,
                        onComplete: function() {
                            music2.pause();
                        }
                    });
                }
                //console.log(locs[locs.length - 2] !== 'room2');
                if (!isMusicPlaying(music) && music) {
                    music.play();
                    // Toggle volume
                    gsap.gsap.to(music, {
                        volume: 1,
                        duration: 2
                    });
                }
            } else {
                // Music 1
                gsap.gsap.to(music, {
                    volume: 0,
                    duration: 1.5,
                    onComplete: function() {
                        music.pause();
                    }
                });
                // Music 2
                if (!isMusicPlaying(music2) && music2) {
                    music2.play();
                    // Toggle volume
                    gsap.gsap.to(music2, {
                        volume: 1,
                        duration: 2
                    });
                }
            }
            localStorage.setItem("backgroundMusic", "playing");
        } else {
            // Toggle volume
            gsap.gsap.to(music, {
                volume: 0,
                duration: 1.5,
                onComplete: function() {
                    music.pause();
                }
            });
            if (isMusicPlaying(music2) && music2) {
                gsap.gsap.to(music2, {
                    volume: 0,
                    duration: 1.5,
                    onComplete: function() {
                        music2.pause();
                    }
                });
            }
            localStorage.setItem("backgroundMusic", "pause");
        }
    }, [
        isPlaying,
        locs,
        music,
        music2,
        router.asPath
    ]);
    var handlePlayPause = function() {
        setIsPlaying(!isPlaying);
    };
    (0,react.useEffect)(function() {
        if (!setHide) {
            gsap.gsap.set("#header", {
                xPercent: 100,
                opacity: 0
            });
            gsap.gsap.to("#header", {
                xPercent: 0,
                opacity: 1,
                ease: "ease.in",
                duration: 1
            });
        } else {
            gsap.gsap.set("#header", {
                xPercent: 100,
                opacity: 0
            });
        }
    }, [
        setHide
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        id: "header",
        className: "".concat((header_module_default()).header, " fixed h-screen top-0 right-0 bg-white z-50 p-5 flex flex-wrap items-center justify-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((header_module_default()).headerTop, " music mb-auto flex flex-wrap items-center justify-center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            setOpenMenu(!openMenu);
                            (0,default_click/* default */.Z)();
                        },
                        onMouseEnter: function() {
                            return (0,default_hover/* default */.Z)();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: openMenu ? "סגירה" : "תפריט"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: function(e) {
                            handlePlayPause();
                            setDisableButton(true);
                            setTimeout(function() {
                                setDisableButton(false);
                            }, 2000);
                            (0,default_click/* default */.Z)();
                        },
                        onMouseEnter: function() {
                            return (0,default_hover/* default */.Z)();
                        },
                        disabled: disableButton,
                        className: "".concat((header_module_default()).sound, " relative flex justify-center items-center rounded-full"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(soundIcon, {
                                data: isPlaying
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "rounded-full"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((header_module_default()).pagination, " navigation"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(nav, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((header_module_default()).logo, " logo mt-auto"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: logo_black.width,
                            height: logo_black.height,
                            src: logo_black.src,
                            alt: "Logo"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fixed top-0 right-full flex justify-center ".concat(openMenu && (header_module_default()).menuOpen, " ").concat((header_module_default()).fullMenu),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 z-10 w-full h-full ".concat((header_module_default()).overlay),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "w-full h-full object-cover object-center",
                            width: credit_bg/* default */.Z === null || credit_bg/* default */.Z === void 0 ? void 0 : credit_bg/* default.width */.Z.width,
                            height: credit_bg/* default */.Z === null || credit_bg/* default */.Z === void 0 ? void 0 : credit_bg/* default.height */.Z.height,
                            src: credit_bg/* default */.Z === null || credit_bg/* default */.Z === void 0 ? void 0 : credit_bg/* default.src */.Z.src,
                            blurDataURL: credit_bg/* default */.Z === null || credit_bg/* default */.Z === void 0 ? void 0 : credit_bg/* default.blurDataURL */.Z.blurDataURL,
                            placeholder: "blur",
                            alt: credit_bg/* default */.Z === null || credit_bg/* default */.Z === void 0 ? void 0 : credit_bg/* default.alt */.Z.alt
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "z-50 relative text-center ".concat((header_module_default()).menuWrapper),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (header_module_default()).menuTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "במסתרים"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "סיפורם של ילדי מסתור בתקופת השואה"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((header_module_default()).menuSet, " ").concat((header_module_default()).menuSet1),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).menuLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "להתחיל מהתחלה"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).menuLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/story/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "בחירת פרקים"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).menuLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "לסיפור של שרה ורות"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center ".concat((header_module_default()).divider)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((header_module_default()).menuSet, " ").concat((header_module_default()).menuSet2),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).menuLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/about/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "אודות"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).menuLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/about/parents-and-teachers/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "להורים ומורים"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).menuLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/story/end/credit/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "קרדיטים"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).menuLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://docs.google.com/forms/d/e/1FAIpQLSczVfdPYvpmGbp09MdyLI7odzhAFUC1cTRxj-bOWOpBOX-IEw/viewform",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: "משוב"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute direction-rtl z-50 ".concat((header_module_default()).button),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowButton/* default */.Z, {
                            onClick: function() {
                                (0,default_click/* default */.Z)();
                            },
                            onMouseEnter: function() {
                                (0,default_hover/* default */.Z)();
                            },
                            className: "p-5",
                            link: "https://www.ganzach.org.il/",
                            openIn: "_blank",
                            color: "#223A57",
                            textColor: "#223A57",
                            text: "לאתר גנזך קידוש השם"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var header_header = (Header);

// EXTERNAL MODULE: ./src/components/layout/layout.module.scss
var layout_module = __webpack_require__(4288);
var layout_module_default = /*#__PURE__*/__webpack_require__.n(layout_module);
;// CONCATENATED MODULE: ./src/components/layout/index.js





var Layout = function(param) {
    var children = param.children, header = param.header, setHide = param.setHide, footer = param.footer, mainDir = param.mainDir, audio = param.audio, audio2 = param.audio2;
    //console.log(audio2);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "body",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "'במסתרים׳ ילדי מסתור בתקופת השואה. תערוכה וירטואלית."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "גנזך קידוש השם מציגים: חוויה אינטראקטיבית על ילדי מסתור בתקופת השואה. למדו על פרידתם מההורים, המסתור, ההצלה והשיקום לאחר המלחמה. מותאם לבני נוער. התחילו בסיור."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            header == "hide" ? "" : /*#__PURE__*/ (0,jsx_runtime.jsx)(header_header, {
                setHide: setHide,
                music: audio,
                music2: audio2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "main",
                className: "main relative z-30 max-w-full overflow-hidden ".concat(mainDir == "ltr" ? (layout_module_default()).dirLtr : (layout_module_default()).dirRtl),
                children: children
            }),
            footer == "hide" ? "" : /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_footer, {})
        ]
    });
};
/* harmony default export */ var layout = (Layout);


/***/ }),

/***/ 6537:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"arrowbutton_button__J60XZ","icon":"arrowbutton_icon__doAqI","text":"arrowbutton_text__jh18f","iconRound":"arrowbutton_iconRound__drjIR","after":"arrowbutton_after__QQfUx"};

/***/ }),

/***/ 5851:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__zXy1G","headerTop":"header_headerTop__1ZNqY","sound":"header_sound__yadPW","pagination":"header_pagination__xWFqf","logo":"header_logo__sAG6F","fullMenu":"header_fullMenu__a9mXJ","menuOpen":"header_menuOpen__g070p","overlay":"header_overlay__UnAzf","menuWrapper":"header_menuWrapper__cygS6","menuSet":"header_menuSet__BkrVd","menuTitle":"header_menuTitle__I0B0E","divider":"header_divider__9mPNS","button":"header_button__7urbN","menuLink":"header_menuLink__0y5lM"};

/***/ }),

/***/ 4288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dirRtl":"layout_dirRtl__BffS7","dirLtr":"layout_dirLtr__4V4Io"};

/***/ }),

/***/ 1658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__TbOu1","navList":"nav_navList__hOnNG","hover":"nav_hover__VuDl9","marker":"nav_marker__HD11K","tooltip":"nav_tooltip__tmmeG","tiptext":"nav_tiptext__Ez94a","active":"nav_active__I1OTE","tipbg":"nav_tipbg__RElQd"};

/***/ }),

/***/ 3511:
/***/ (function(module) {

module.exports = "data:audio/mpeg;base64,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"

/***/ }),

/***/ 1966:
/***/ (function(module) {

module.exports = "data:audio/mpeg;base64,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"

/***/ })

}]);